/* This regex requires the entire string to match the pattern for allowed chars */
export const bigqueryAllowedIdentifierCharactersRegex = /^[a-zA-Z0-9 _]+$/;

// Opposite of the above regex, finds any invalid characters
export const bigqueryDisallowedIdentifierCharactersRegex = /[^a-zA-Z0-9 _]/g;

// XXX: This is exported primarily for use in tests. DO NOT USE THIS IN
// PRODUCTION FUNCTIONS, strongly prefer disallowing special characters in the
// first place.
//
// Note that the escapeIdentifier method in the below implementation of
// SqlTransformer will throw an error if any of the above characters are
// present, so that can be used as a gate to prevent these characters from being
// used in the first place.
export function sanitizeBigqueryIdentifier(identifier: string): string {
  return identifier.replaceAll(bigqueryDisallowedIdentifierCharactersRegex, "");
}
